import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserSessionStorageService {

  /**
   * Method: Add item value in sessionStorage
   * @param name - Storage key
   * @param value - Value stored under the key
   */
  public setItem(name: string, value: string): void {
    if (!name) {
      return;
    }
    sessionStorage.setItem(name, value);
  }

  /**
   * Method: Get item value from sessionStorage
   * @param name - Storage key
   */
  public getItem(name: string): string | null {
    return name ? sessionStorage.getItem(name) : null;
  }

  /**
   * Method: Remove item value from sessionStorage
   * @param name - Storage key
   */
  public removeItem(name: string): void {
    if (!name) {
      return;
    }
    sessionStorage.removeItem(name);
  }

  /**
   * Method: Remove every item from sessionStorage
   */
  public clearAll(): void {
    sessionStorage.clear();
  }

}
